//
// user-settings.js
//
// Copyright (c) 2015 by Curalate, Inc.
//

((() => {
    angular.module('curalate').controller('UserSettingsController', ['$scope', '$location', 'UserSettingsApiService',

        ($scope, $location, UserSettingsApiService) => {
            const handleRequest = fetchPromise => {
                $scope.fetchingPromise = fetchPromise.then(res => {
                    $scope.userSettingsData = res.data.settings;
                    $scope.user = res.data.user;
                    $scope.userSettingsDataStr = JSON.stringify(res.data);
                    $location.search('id', $scope.user.userId);
                }, error => {
                    $scope.error = error;
                }).finally(() => {
                    $scope.fetchingPromise = undefined;
                });
            };

            const clearResults = () => {
                $scope.userSettingsData = undefined;
                $scope.error = undefined;
            };

            $scope.selectedUserId = undefined;
            $scope.selectedEmail = undefined;
            $scope.fetchingPromise = undefined;

            $scope.$watch('selectedUserId', (id) => {
                clearResults();
                if (!id) return;
                handleRequest(UserSettingsApiService.readAllFeatures(id));
            });

            $scope.$watch('selectedEmail', email => {
                clearResults();
                if (!email) return;

                handleRequest(UserSettingsApiService.readAllFeaturesByEmail(email));
            });

            const requestId = parseInt($location.search().id);
            if (!isNaN(requestId)) {
                $scope.selectedUserId = requestId.toString();
            }
        },
    ]);
}))();
